// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"7965b805","766":"a31f6042","830":"ccb58249"}[chunkId] + ".chunk.js";
};